export const RolesAndPermissionsEndpoints = {
  GET_ALL_ROLES: '/api/admin/roles',
  CREATE_ROLE: '/api/admin/roles',
  UPDATE_ROLE: '/api/admin/roles',
  DELETE_ROLE: '/api/admin/roles',
};
